module.exports = __webpack_public_path__ + "static/media/belcolor__10.5cd366a7.jpg";